import React from 'react';

export const CodepenIcon = () => {
    return (<>
        <svg 
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 100 100"
            stroke="#511b1a"
            strokeWidth={7}
        >
            <polygon 
                className="cls-1" 
                points="4.22 35.58 49.35 65.1 95.78 35.45 49.35 3.88 4.22 35.58"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <polyline 
                className="cls-1" 
                points="49.35 3.88 49.35 34.63 4.22 64.55"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <polyline 
                className="cls-1" 
                points="4.22 35.58 4.22 65.1 49.35 96.12 95.78 65.65 95.78 35.45"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <line 
                className="cls-1" 
                x1="95.78" y1="65.65" x2="49.35" y2="34.63"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <line 
                className="cls-1" 
                x1="49.35" y1="65.1" x2="49.35" y2="95.57"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    </>)
}